import { noop, T } from '@/helpers'
import { api, type TOA } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'
import { model as session } from '~/entities/session'
import { formatToa } from '~/entities/toa'

// *
// * events
// *

export const init = createEvent()
export const getToa = createEvent()
export const acceptToa = createEvent()
export const declineToa = createEvent()

// get TOA request effect
export const getToaFx = attach({ effect: api.session.getToaFx })

// accept TOA request effect
export const acceptToaFx = attach({ effect: api.session.acceptToaFx })

// sign out request effect
export const signOutFx = attach({ effect: api.session.signOutFx })

// TOA message and variables
export const $toa = createStore<TOA | null>(null)
  .on(api.session.$toa, (__, toa) => formatToa(toa))
  .reset(init, getToa)

// lock interface after successful registration
export const $lockedAccepting = createStore<boolean>(false)
  .reset(init)
  .on(acceptToaFx.done, T)

export const $lockedDeclining = createStore<boolean>(false)
  .reset(init)
  .on(signOutFx.done, T)

export const $wasLoadingError = createStore<boolean>(false)
  .on(getToaFx.fail, () => true)
  .reset(init, getToaFx.doneData)

// show error on TOA loading failed
export const $loading = createStore<string | null>(null)
  .on($toa, (_, toa) => (toa?.message ? null : 'toa_loading_error'))
  .on(getToaFx.fail, () => 'toa_loading_error')
  .reset(init, getToa)

// show error on TOA acceptance failed
export const $accept = createStore<string | null>(null)
  .on(acceptToaFx.fail, () => 'toa_error')
  .reset(init, getToa, acceptToa)

export const $getToaLoading = getToaFx.pending

// errors
export const error = {
  $loading,
  $accept,
}

// load TOA on route init
sample({
  clock: init,
  target: getToa,
})

// load TOA on route init
sample({
  clock: getToa,
  target: getToaFx,
})

// accept TOA
sample({
  clock: acceptToa,
  target: acceptToaFx,
})

// re-request account on TOA acceptance
sample({
  clock: acceptToaFx.done,
  fn: noop,
  target: session.getAccountFx,
})

// sign out on declining TOA
sample({
  clock: declineToa,
  target: signOutFx,
})
